"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var pagination_1 = require("./pagination");

var class_validator_jsonschema_1 = require("class-validator-jsonschema");

var class_transformer_1 = require("class-transformer");

var LotTypes;

(function (LotTypes) {
  LotTypes["House"] = "Maison";
  LotTypes["Appartment"] = "Appartement";
  LotTypes["Duplex"] = "Duplex";
  LotTypes["Loft"] = "Loft";
  LotTypes["Villa"] = "Villa";
  LotTypes["Terrain"] = "Terrain";
})(LotTypes = exports.LotTypes || (exports.LotTypes = {}));

var LotSubTypes;

(function (LotSubTypes) {
  LotSubTypes["Villa"] = "Villa";
})(LotSubTypes = exports.LotSubTypes || (exports.LotSubTypes = {}));

var FiscalTools;

(function (FiscalTools) {
  FiscalTools["Pinel"] = "Pinel";
  FiscalTools["LMNP"] = "LMNP";
  FiscalTools["LMP"] = "LMP";
  FiscalTools["Malraux"] = "Malraux";
  FiscalTools["TVA55"] = "TVA 5.5";
  FiscalTools["PTZ"] = "PTZ";
  FiscalTools["PTZPlus"] = "PTZ+";
})(FiscalTools = exports.FiscalTools || (exports.FiscalTools = {}));

var PinelZones;

(function (PinelZones) {
  PinelZones["A"] = "A";
  PinelZones["ABis"] = "A Bis";
  PinelZones["B1"] = "B1";
  PinelZones["B2"] = "B2";
  PinelZones["C"] = "C";
})(PinelZones = exports.PinelZones || (exports.PinelZones = {}));

var UsageTypes;

(function (UsageTypes) {
  UsageTypes["Locative"] = "Locatif";
  UsageTypes["Ownership"] = "Acccession";
  UsageTypes["LocativeOrOwnership"] = "Locatif ou Accession";
})(UsageTypes = exports.UsageTypes || (exports.UsageTypes = {}));

var ParkingTypes;

(function (ParkingTypes) {
  ParkingTypes["Garage"] = "Garage";
  ParkingTypes["Outside"] = "Outside";
  ParkingTypes["ParkingSimple"] = "Parking Simple";
  ParkingTypes["ParkingDouble"] = "Parking Double";
  ParkingTypes["NonInclus"] = "Non inclus";
})(ParkingTypes = exports.ParkingTypes || (exports.ParkingTypes = {}));

var HeatingTypes;

(function (HeatingTypes) {
  HeatingTypes["radiateur"] = "radiateur";
  HeatingTypes["sol"] = "sol";
  HeatingTypes["mixte"] = "mixte";
  HeatingTypes["gaz"] = "gaz";
  HeatingTypes["gaz radiateur"] = "gaz radiateur";
  HeatingTypes["gaz sol"] = "gaz sol";
  HeatingTypes["gaz mixte"] = "gaz mixte";
  HeatingTypes["fuel"] = "fuel";
  HeatingTypes["fuel radiateur"] = "fuel radiateur";
  HeatingTypes["fuel sol"] = "fuel sol";
  HeatingTypes["fuel mixte"] = "fuel mixte";
  HeatingTypes["\xE9lectrique"] = "\xE9lectrique";
  HeatingTypes["\xE9lectrique radiateur"] = "\xE9lectrique radiateur";
  HeatingTypes["\xE9lectrique sol"] = "\xE9lectrique sol";
  HeatingTypes["\xE9lectrique mixte"] = "\xE9lectrique mixte";
  HeatingTypes["collectif"] = "collectif";
  HeatingTypes["collectif radiateur"] = "collectif radiateur";
  HeatingTypes["collectif sol"] = "collectif sol";
  HeatingTypes["collectif mixte"] = "collectif mixte";
  HeatingTypes["collectif gaz"] = "collectif gaz";
  HeatingTypes["collectif gaz radiateur"] = "collectif gaz radiateur";
  HeatingTypes["collectif gaz sol"] = "collectif gaz sol";
  HeatingTypes["collectif gaz mixte"] = "collectif gaz mixte";
  HeatingTypes["collectif fuel"] = "collectif fuel";
  HeatingTypes["collectif fuel radiateur"] = "collectif fuel radiateur";
  HeatingTypes["collectif fuel sol"] = "collectif fuel sol";
  HeatingTypes["collectif fuel mixte"] = "collectif fuel mixte";
  HeatingTypes["collectif \xE9lectrique"] = "collectif \xE9lectrique";
  HeatingTypes["collectif \xE9lectrique radiateur"] = "collectif \xE9lectrique radiateur";
  HeatingTypes["collectif \xE9lectrique sol"] = "collectif \xE9lectrique sol";
  HeatingTypes["collectif \xE9lectrique mixte"] = "collectif \xE9lectrique mixte";
  HeatingTypes["individuel"] = "individuel";
  HeatingTypes["individuel radiateur"] = "individuel radiateur";
  HeatingTypes["individuel sol"] = "individuel sol";
  HeatingTypes["individuel mixte"] = "individuel mixte";
  HeatingTypes["individuel gaz"] = "individuel gaz";
  HeatingTypes["individuel gaz radiateur"] = "individuel gaz radiateur";
  HeatingTypes["individuel gaz sol"] = "individuel gaz sol";
  HeatingTypes["individuel gaz mixte"] = "individuel gaz mixte";
  HeatingTypes["individuel fuel"] = "individuel fuel";
  HeatingTypes["individuel fuel radiateur"] = "individuel fuel radiateur";
  HeatingTypes["individuel fuel sol"] = "individuel fuel sol";
  HeatingTypes["individuel fuel mixte"] = "individuel fuel mixte";
  HeatingTypes["individuel \xE9lectrique"] = "individuel \xE9lectrique";
  HeatingTypes["individuel \xE9lectrique radiateur"] = "individuel \xE9lectrique radiateur";
  HeatingTypes["individuel \xE9lectrique sol"] = "individuel \xE9lectrique sol";
  HeatingTypes["individuel \xE9lectrique mixte"] = "individuel \xE9lectrique mixte";
  HeatingTypes["climatisation r\xE9versible"] = "climatisation r\xE9versibl";
  HeatingTypes["climatisation r\xE9versible centrale"] = "climatisation r\xE9versible centrale";
  HeatingTypes["climatisation r\xE9versible "] = "climatisation r\xE9versible individuel";
})(HeatingTypes = exports.HeatingTypes || (exports.HeatingTypes = {}));

var LotPublicDTO = function LotPublicDTO() {
  _classCallCheck(this, LotPublicDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], LotPublicDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], LotPublicDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "price", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "floor", void 0);

__decorate([class_validator_1.IsEnum(LotTypes), __metadata("design:type", String)], LotPublicDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsEnum(LotSubTypes), __metadata("design:type", String)], LotPublicDTO.prototype, "subType", void 0);

__decorate([class_validator_1.IsEnum(FiscalTools), __metadata("design:type", String)], LotPublicDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsEnum(PinelZones), __metadata("design:type", String)], LotPublicDTO.prototype, "pinelZone", void 0);

__decorate([class_validator_1.IsEnum(ParkingTypes), __metadata("design:type", String)], LotPublicDTO.prototype, "parkingType", void 0);

__decorate([class_validator_1.IsEnum(HeatingTypes), __metadata("design:type", String)], LotPublicDTO.prototype, "heatingType", void 0);

__decorate([class_validator_1.IsEnum(UsageTypes), __metadata("design:type", String)], LotPublicDTO.prototype, "usageType", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "southExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "northExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "eastExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "westExposition", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "exteriorsCount", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "bbc", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "elevator", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "RT2012", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotPublicDTO.prototype, "zeroLoan", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "basementNb", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "basementSurface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "balconyNb", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "balconySurface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "terraceNb", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "terraceSurface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "yardNb", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotPublicDTO.prototype, "yardSurface", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], LotPublicDTO.prototype, "programId", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotPublicDTO.prototype, "plan", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotPublicDTO.prototype, "threeDPlan", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotPublicDTO.prototype, "rentalProfitability", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotPublicDTO.prototype, "pinelProfitability", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], LotPublicDTO.prototype, "externalId", void 0);

exports.LotPublicDTO = LotPublicDTO;

var LotPrivateDTO =
/*#__PURE__*/
function (_LotPublicDTO) {
  _inherits(LotPrivateDTO, _LotPublicDTO);

  function LotPrivateDTO() {
    _classCallCheck(this, LotPrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(LotPrivateDTO).apply(this, arguments));
  }

  return LotPrivateDTO;
}(LotPublicDTO);

exports.LotPrivateDTO = LotPrivateDTO;

var LotCreationDTO = function LotCreationDTO() {
  _classCallCheck(this, LotCreationDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], LotCreationDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotCreationDTO.prototype, "price", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotCreationDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotCreationDTO.prototype, "floor", void 0);

__decorate([class_validator_1.IsEnum(LotTypes), __metadata("design:type", String)], LotCreationDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsEnum(LotSubTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "subType", void 0);

__decorate([class_validator_1.IsEnum(FiscalTools), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsEnum(PinelZones), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "pinelZone", void 0);

__decorate([class_validator_1.IsEnum(ParkingTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "parkingType", void 0);

__decorate([class_validator_1.IsEnum(HeatingTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "heatingType", void 0);

__decorate([class_validator_1.IsEnum(UsageTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "usageType", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "southExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "northExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "eastExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "westExposition", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], LotCreationDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "exteriorsCount", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "bbc", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "elevator", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "RT2012", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], LotCreationDTO.prototype, "zeroLoan", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "basementNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "basementSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "balconyNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "balconySurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "terraceNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "terraceSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "yardNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotCreationDTO.prototype, "yardSurface", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], LotCreationDTO.prototype, "programId", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "plan", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "threeDPlan", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotCreationDTO.prototype, "externalId", void 0);

__decorate([class_validator_1.IsArray(), class_validator_1.IsOptional(), __metadata("design:type", Array)], LotCreationDTO.prototype, "pictures", void 0);

exports.LotCreationDTO = LotCreationDTO;

var LotUpdateDTO = function LotUpdateDTO() {
  _classCallCheck(this, LotUpdateDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "price", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "floor", void 0);

__decorate([class_validator_1.IsEnum(LotTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsEnum(LotSubTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "subType", void 0);

__decorate([class_validator_1.IsEnum(FiscalTools), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsEnum(PinelZones), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "pinelZone", void 0);

__decorate([class_validator_1.IsEnum(ParkingTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "parkingType", void 0);

__decorate([class_validator_1.IsEnum(HeatingTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "heatingType", void 0);

__decorate([class_validator_1.IsEnum(UsageTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "usageType", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "southExposition", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "northExposition", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "eastExposition", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "westExposition", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "exteriorsCount", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "bbc", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "elevator", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "RT2012", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], LotUpdateDTO.prototype, "zeroLoan", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "basementNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "basementSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "balconyNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "balconySurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "terraceNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "terraceSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "yardNb", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], LotUpdateDTO.prototype, "yardSurface", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "programId", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "planId", void 0);

__decorate([class_validator_1.IsUUID(), class_validator_1.IsOptional(), __metadata("design:type", String)], LotUpdateDTO.prototype, "threeDPlanId", void 0);

exports.LotUpdateDTO = LotUpdateDTO;
var LotOrderEnum;

(function (LotOrderEnum) {
  LotOrderEnum["createDate"] = "createDate";
})(LotOrderEnum = exports.LotOrderEnum || (exports.LotOrderEnum = {}));

var LotPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(LotPaginationResponse, _pagination_1$Paginat);

  function LotPaginationResponse() {
    _classCallCheck(this, LotPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(LotPaginationResponse).apply(this, arguments));
  }

  return LotPaginationResponse;
}(pagination_1.PaginationResponse);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return LotPublicDTO;
}), class_validator_jsonschema_1.JSONSchema({
  example: [{
    test: 'lol'
  }]
}), __metadata("design:type", Array)], LotPaginationResponse.prototype, "data", void 0);

exports.LotPaginationResponse = LotPaginationResponse;